import React, { Component } from 'react';

import { Folder } from './Folder/Folder';
import { Layer } from './Layer/Layer';
import './LayersList.css'


export class LayersList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            expand: false
        }
    }

    render() {
        return (
            <div className='layersList'>
                <ul className='treeRoot'>
                    {this.parseData(this.props.data)}
                </ul>                
            </div>
        );
    }

    parseData = (data) => {
        return data.map((item, index)=>{
            return (
                item.Class=="FOLDER" ?
                <Folder key={item.Name} data={item} /*name={item.Name} data={item.Layers} class={item.Class}*/ updateLayerList = {this.props.updateLayerList}/> :
                <Layer key={item.Name} data={item} /*name={item.Name} data={item.FolderFullName} class={item.Class}*/ updateLayerList = {this.props.updateLayerList}/>
            );
        });
    }    
}